import md5 from 'js-md5'

export default {
  authorization: function () {
    const token = window.openBjStore.getToken()
    if (!token) {
      return ''
    }
    const timestamp = new Date().getTime()
    if (!token.principal) {
      return ''
    }
    if (!token.credentials) {
      return ''
    }
    let credentials = md5(token.principal + token.credentials)
    credentials = md5(credentials + timestamp)
    const authKey = btoa(token.principal + '.' + credentials + '.' + timestamp)
    return authKey
  },
  storagePut: function (key, value) {
    sessionStorage.setItem(key, value)
  },
  storageGet: function (key) {
    return sessionStorage.getItem(key)
  },
  storagePutObj: function (key, value) {
    if (!value) {
      this.storagePut(key, value)
    }
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  storageGetObj: function (key) {
    const value = sessionStorage.getItem(key)
    if (!value) {
      return value
    }
    return JSON.parse(value)
  },
  // "deptId|deptName|detpParentId|districtId|userId"
  userMsg: function (key) {
    const value = this.storageGetObj('user.' + key)
    if (value) {
      return value
    }
    $.ajax({
      url: this.url().server + 'ucenter2/ucenter/user/getUserDeptDist',
      headers: { Authorization: this.authorization() },
      async: false,
      success: function (data) {
        for (const key in data.data) {
          this.storagePutObj('user.' + key, data.data[key])
        }
      }
    })
    return this.storageGetObj('user.' + key)
  },
  userTypes: { 0: '管理员', 1: '政府部门', 2: '企业', 3: '个人' },
  userTypeCurrent: function () {
    return this.userTypes[this.storageGet('userType')]
  },
  userAccount: function () {
    return JSON.parse(this.storageGet('user')).account
  },
  dateFormat: function (date, fmt) {
    if (!date || !fmt) {
      return ''
    }
    if (typeof date === 'number') {
      date = new Date(date)
    }
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
    }
    return fmt
  }
}
